import React from "react";
import { Grid } from "@mui/material";
import { format } from "date-fns";
import { COUNTRIES, STATES, TIMEZONES } from "@constants";
import { dateWithoutTimezone } from "utils/dateWithoutTimezone";
import { formatToPhoneNumber } from "utils/formatFormFields";
import FieldItem from "../../Widgets/FieldItem";
import { ClientInfo } from "./interface";

interface ViewFieldsProps {
  clientInfo: ClientInfo;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ clientInfo }) => {
  const formatDate = (date: any) => {
    if (!date) return "-";
    try {
      return format(dateWithoutTimezone(date), "PP");
    } catch {
      return "-";
    }
  };

  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <Grid item xs={12}>
        <FieldItem label="First name" value={clientInfo.name || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Preferred first name" value={clientInfo.preferred_first_name || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Last name" value={clientInfo.child_last_name || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Date of birth" value={formatDate(clientInfo.dob)} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Sex assigned at birth" value={clientInfo.gender || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Identified gender" value={clientInfo.identified_gender || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Transgender" value={clientInfo.transgender ? "Yes" : "No"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Pronouns" value={clientInfo.pronouns || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Client lives with" value={clientInfo.lives_with || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Address" value={clientInfo.line1 || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Address 2" value={clientInfo.line2 || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="State" value={STATES[clientInfo.state as keyof typeof STATES] || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="City" value={clientInfo.city || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="ZIP code" value={clientInfo.zip || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Time zone"
          value={
            TIMEZONES[clientInfo.timezone_jhi as keyof typeof TIMEZONES] ||
            TIMEZONES[clientInfo.timezone as keyof typeof TIMEZONES] ||
            "-"
          }
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Country"
          value={COUNTRIES[clientInfo.country as keyof typeof COUNTRIES] || "-"}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Race & ethnicity" value={clientInfo.ethnicity || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Primary language" value={clientInfo.primary_language || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Interpreter required"
          value={clientInfo.needs_interpreter ? "Yes" : "No"}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Emergency contact" value={clientInfo.emergency_contact_name || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Emergency contact phone number"
          value={
            clientInfo.emergency_contact_phone_number
              ? formatToPhoneNumber(clientInfo.emergency_contact_phone_number)
              : "-"
          }
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Emergency contact relationship to client"
          value={clientInfo.emergency_contact_relationship_to_client || "-"}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Pre-authorization required"
          value={clientInfo.pre_auth_required ? "Yes" : "No"}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Requires tablet" value={clientInfo.requires_tablet ? "Yes" : "No"} />
      </Grid>
    </Grid>
  );
};

export default ViewFields;
